import { render, staticRenderFns } from "./LessonQuestion.vue?vue&type=template&id=5644f54a&scoped=true&"
import script from "./LessonQuestion.vue?vue&type=script&lang=js&"
export * from "./LessonQuestion.vue?vue&type=script&lang=js&"
import style0 from "./LessonQuestion.vue?vue&type=style&index=0&id=5644f54a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5644f54a",
  null
  
)

export default component.exports